import React, { useState } from 'react';
import { Container } from '../Container/Container';
import { HudIcon } from '../Icons/HudIcons';
import {
  PromptContainer,
  Prompt,
  ToggleButton,
  ShowIcon,
  CopyPromptButton,
} from './FixItPrompt.styles';

const CopyToClipboardButton = ({
  textToCopy,
  onCopyPrompt,
}: {
  textToCopy: string;
  onCopyPrompt: () => void;
}) => {
  const [buttonText, setButtonText] = useState('Copy prompt to fix');
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setButtonText('Prompt Copied!');
      setIsCopied(true);
      onCopyPrompt();

      // Reset button text after 5 seconds
      setTimeout(() => {
        setButtonText('Copy prompt to fix');
        setIsCopied(false);
      }, 5000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <CopyPromptButton variant="glow" onClick={handleCopyToClipboard}>
      <HudIcon icon={isCopied ? 'designSystem.check' : 'designSystem.copy'} size="20px" />
      {buttonText}
    </CopyPromptButton>
  );
};

const FixItPrompt = ({
  fixItPrompt,
  onCopyPrompt,
}: {
  fixItPrompt: string;
  onCopyPrompt: () => void;
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Container
      title="Fix issue using Agentic"
      variant="solid"
      aria-label="Fix It Prompt"
      topRightSection={
        <CopyToClipboardButton textToCopy={fixItPrompt} onCopyPrompt={onCopyPrompt} />
      }
      topRightMargin={false}
    >
      <div>
        This prompt contains Hud context and instructions for AI Coding Agent to solve
        this issue.
      </div>
      <PromptContainer expanded={expanded}>
        <Prompt expanded={expanded}>{fixItPrompt}</Prompt>
        <ToggleButton variant="text" onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Minimize Prompt' : 'Full Prompt'}
          <ShowIcon icon="menu.chevronDown" size="20px" expanded={!expanded} />
        </ToggleButton>
      </PromptContainer>
    </Container>
  );
};

export default FixItPrompt;
